import { ActionCreator } from "redux";
import {
	ActionType,
	InquiryListDateRangeChangedAction,
	InquiryListHighlightedInquiryChangedAction
} from "./type";

export const changeInquiryListDateRange: ActionCreator<
	InquiryListDateRangeChangedAction
> = (startDate: Date, endDate: Date) => ({
	type: ActionType.InquiryListDateRangeChanged,
	payload: {
		startDate,
		endDate
	}
});

export const changeHighlightedInquiry: ActionCreator<
	InquiryListHighlightedInquiryChangedAction
> = (id: string) => ({
	type: ActionType.InquiryListHighlightedInquiryChanged,
	payload: {
		id
	}
});
